export const ticketQuickReply = {
  name: "Quick Reply |||| Quick Replies",
  fields: {
    shortcut: "Shortcut",
    title: "Title",
    content: "Content",
    ticketQueueId: "Queue",
  },
  helpers: {
    shortcut: "E.g.: /greeting, /price, /hours",
    content:
      "Use {{contact.name}} for contact name, {{agent.name}} for agent name",
  },
};
